import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { appRoutes } from "@/app";
import { Tracking } from "@/components/vendors";
import "@/components/vendors/monitoring/bootstrap";
import { AuthProvider } from "@/modules/auth";

import "./global.scss";

import "@counselpro/counselkit/dist/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Tracking>
      <AuthProvider>
        <RouterProvider router={createBrowserRouter(appRoutes)} />
      </AuthProvider>
    </Tracking>
  </React.StrictMode>,
);
